export default __webpack_public_path__ + "img/filter.f3d58529.svg";